module.exports = __webpack_public_path__ + "img/beach-person-water-parasol.6a312301.svg";